import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-base flex justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-sky-blue font-medium flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-[22px] leading-7 text-[#80A0FE]" }, "382 students")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bg-elements-bg h-[2px] mt-4 mx-5" }, null, -1)
const _hoisted_4 = { class: "text-base pt-4 px-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-grey font-medium text-xl" }, " Average Lessons to Complete ", -1)
const _hoisted_6 = { class: "flex gap-4 mt-1" }
const _hoisted_7 = { class: "text-medium" }
const _hoisted_8 = { class: "text-4xl font-semibold py-1 text-[#9F94FD]" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "has-text-centered" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "37 students")
], -1)
const _hoisted_10 = { class: "text-base pt-4 px-2" }
const _hoisted_11 = { class: "flex gap-5 justify-between align" }
const _hoisted_12 = { class: "bg-white rounded-2xl p-5 pb-3 shadow-journeys w-3/12 flex flex-col justify-between overflow-hidden" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-grey font-medium text-xl mb-2" }, "Gaps Analysis", -1)
const _hoisted_14 = { class: "overflow-y-scroll max-h-[30rem] no-scrollbar" }
const _hoisted_15 = { class: "flex justify-between items-center" }
const _hoisted_16 = { class: "flex-col items-center justify-between" }
const _hoisted_17 = { class: "font-medium" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h1", { class: "text-sm text-slate-400" }, "10 students", -1)
const _hoisted_19 = {
  key: 0,
  class: "bg-elements-bg h-[2px] w-full mt-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", { class: "w-full bg-transparent border-[1px] border-[#81A0FD] rounded-[30px] text-[#81A0FD] mt-2" }, " View detail ", -1)
const _hoisted_21 = { class: "flex flex-col w-full justify-between gap-3" }
const _hoisted_22 = { class: "w-full h-full bg-white rounded-2xl p-5 shadow-journeys" }
const _hoisted_23 = { class: "flex w-full items-center justify-between" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-grey font-medium text-xl" }, " Catch Up Progress ", -1)
const _hoisted_25 = ["value"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "w-full p-4 flex gap-5 justify-center items-center bg-gradient-to-r to-[#70B3FF4D] from-[#9C80FF4D] rounded-2xl text-[#6C6290]" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-medium text-base" }, " Why does the Catch Up Progress seem to 'reset' sometimes? "),
  /*#__PURE__*/_createElementVNode("button", { class: "px-4 p-1 bg-white font-medium text-sm rounded-[30px]" }, " Read the article to understand ")
], -1)

import { ref } from "vue";
import StackedBarComponent from "../components/ProgressBarGraphComponent.vue";
import SchoolFilterComponent from "@/components/global/SchoolFilterComponent.vue";
import juniorHigh from "@/utils/junior-high.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressView',
  setup(__props) {

const subject = ref("Maths");

const threads = () => {
  if (subject.value == "English") {
    return [
      { threadName: "Oral Comprehension", threadId: 1, completion: 10 },
      { threadName: "Written Comprehension", threadId: 2, completion: 12 },
      { threadName: "Visual Comprehension", threadId: 3, completion: 13 },
      { threadName: "Language Structure", threadId: 4, completion: 14 },
    ];
  }
  return [
    { threadName: "Numbers", threadId: 1, completion: 12 },
    { threadName: "Fractions", threadId: 2, completion: 11 },
    { threadName: "Measurement", threadId: 3, completion: 6 },
    { threadName: "Data Literacy", threadId: 4, completion: 2 },
    { threadName: "Problem Solving", threadId: 5, completion: 5 },
    { threadName: "Patterns & Algebra", threadId: 6, completion: 10 },
    { threadName: "Space & Shape", threadId: 7, completion: 10 },
  ];
};

const selectedThread = threads()[0].threadName;

const concepts = () => {
  // use selected grade to determine util -> using jh for now
  let thread = threads().find((thread) => thread.threadName == selectedThread);
  let threadId = thread?.threadId;

  return juniorHigh["1"];
};

const threadSelectSize = () => {
  switch (selectedThread) {
    case "Numbers":
    case "Fractions":
      return "w-1/7";
    case "Data Literacy":
    case "Measurement":
      return "w-1/6";
    case "Problem Solving":
    case "Space & Shape":
    case "Patterns & Algebra":
    case "Oral Comprehension":
    case "Language Structure":
      return "w-1/5";
    case "Visual Comprehension":
    case "Written Comprehension":
      return "w-1/4";
  }
  return "";
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(SchoolFilterComponent),
      _hoisted_2
    ]),
    _hoisted_3,
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threads(), (thread, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(
          'text-center p-3 px-4 bg-white rounded-2xl shadow-journeys' +
          (subject.value == 'English' ? ' w-3/12' : ' w-1/7')
        )
          }, [
            _createElementVNode("h1", _hoisted_7, _toDisplayString(thread.threadName), 1),
            _createElementVNode("h1", _hoisted_8, _toDisplayString(thread.completion), 1),
            _hoisted_9
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(concepts(), (concept, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "flex-col justify-start items-start py-1"
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h1", _hoisted_17, _toDisplayString(concept.name), 1),
                    _hoisted_18
                  ])
                ]),
                (index != concepts().length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _hoisted_20
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", {
                class: _normalizeClass('rounded-[30px] bg-[#928CFF] px-6 ' + threadSelectSize())
              }, [
                _withDirectives(_createElementVNode("select", {
                  id: "small",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedThread) ? (selectedThread).value = $event : null)),
                  class: "py-2 w-full text-base text-white rounded-[30px] bg-transparent outline-none border-none ring-transparent focus:text-black"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threads(), (thread, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: thread.threadName
                    }, _toDisplayString(thread.threadName), 9, _hoisted_25))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(selectedThread)]
                ])
              ], 2)
            ]),
            _createVNode(StackedBarComponent)
          ]),
          _hoisted_26
        ])
      ])
    ])
  ], 64))
}
}

})